import { render, staticRenderFns } from "./o-modal.vue?vue&type=template&id=8af07ee8&scoped=true&"
import script from "./o-modal.vue?vue&type=script&lang=js&"
export * from "./o-modal.vue?vue&type=script&lang=js&"
import style0 from "./o-modal.vue?vue&type=style&index=0&id=8af07ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af07ee8",
  null
  
)

export default component.exports